import React from "react";
import { Props as ReactInputMaskProps } from "react-input-mask";
import * as S from "./style";

type DSInputBaseProps = {
  touched?: boolean;
  error?: boolean;
  name: string;
};

type DSStandardInputProps = DSInputBaseProps &
  React.InputHTMLAttributes<HTMLInputElement> & {
    mask?: never;
  };

type DSMaskedInputProps = DSInputBaseProps & ReactInputMaskProps;

export type DSInputProps = DSStandardInputProps | DSMaskedInputProps;

export function DSInput({ touched, error, name, ...rest }: DSInputProps) {
  const isInputWithMask = !!rest.mask;

  if (isInputWithMask) {
    return (
      <S.CustomReactInputMask id={name} error={touched && error} {...rest} />
    );
  }

  return <S.CustomInput id={name} error={touched && error} {...rest} />;
}
